import { render, staticRenderFns } from "./ArticleSection.vue?vue&type=template&id=5163b659&scoped=true&"
import script from "./ArticleSection.vue?vue&type=script&lang=js&"
export * from "./ArticleSection.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSection.vue?vue&type=style&index=0&id=5163b659&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5163b659",
  null
  
)

export default component.exports